import { Box, Typography } from "@mui/material";
import React from "react";
import VideoCard from "./VideoCard";

export default function LastViews() {
  return (
    <Box
      sx={{
        marginTop: "60px",
        // border: "1px solid gray",
      }}
    >
      <Box
        sx={{
          paddingX: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "600",
          }}
        >
          آموزش‌های در حال مشاهده
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 3,
          overflowX: "auto",
          border: "1ps solid gray",
          height: 200,
          gap: "16px",
          display: "flex",
          pb: 3,
          pr: 1,
          pl: 1,
        }}
      >
        <VideoCard />
        <VideoCard />
        <VideoCard />
        <VideoCard />
        <VideoCard />
      </Box>
    </Box>
  );
}
